(function () {
  const newest = (a,b) => Date.parse(b.date) - Date.parse(a.date);
  const eligible = (reviews, minimum) => reviews.filter(r => Number(r.rating) >= minimum && Number(r.rating) <= 5).sort(newest);
  function clarity(review) {
    const text = review.text || '';
    const words = text.split(/\s+/).filter(Boolean).length;
    let score = words >= 15 && words <= 65 ? 30 : words > 100 ? -30 : 0;
    for (const expression of [/rosas|roses|flowers|flores/i,/caixa|box|packag|embalag/i,/presente|gift|namorada|surpresa|surprise/i,/fresc|fresh|qualidade|quality|elegant/i,/entrega|deliver|chegou|arrived/i]) if (expression.test(text)) score += 8;
    if (/\b(ofereci|presente|ela|adorou|estava|muito|obrigad)\b/i.test(text)) score += 8;
    if (words > 150) score -= 20;
    return score;
  }
  function homeSelection(reviews) {
    const five = eligible(reviews,5);
    const selected = [...five.filter(r=>r.source==='Judge.me').slice(0,3),...five.filter(r=>r.source==='Google').slice(0,2)].sort(newest);
    const feature = [...selected].filter(r=>r.text.trim()).sort((a,b)=>clarity(b)-clarity(a)||newest(a,b))[0];
    return {feature,rest:selected.filter(r=>r!==feature),selected};
  }
  const api = {eligible,homeSelection,clarity};
  globalThis.QRosesReviewLogic = api;
  if (typeof document === 'undefined') return;
  const configNode = document.querySelector('#qroses-review-config');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const words = config.words;
  const escape = value => String(value ?? '').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const origin = source => source==='Google' ? '<span class="review-origin origin"><img class="google-logo" src="https://www.gstatic.com/images/branding/product/ico/googleg_lodp.ico" alt="">Google Reviews</span>' : '<span class="review-origin origin review-origin--judge"><span class="judge-symbol judge" aria-hidden="true">✓</span>Judge.me</span>';
  let copyId=0;
  const content = (text,lines=4) => {
    const id='qroses-review-text-'+(++copyId);
    const comment=text.trim()?'“'+text+'”':words.noComment;
    return '<div class="review-copy" data-lines="'+lines+'"><p class="review-text" id="'+id+'">'+escape(comment)+'</p><button class="review-expand" type="button" aria-expanded="false" aria-controls="'+id+'">'+escape(words.readMore)+'</button></div>';
  };
  function measureComments() {
    document.querySelectorAll('.review-copy').forEach(copy=>{
      const button=copy.querySelector('.review-expand'),text=copy.querySelector('.review-text');
      button.hidden=!copy.classList.contains('is-expanded')&&text.scrollHeight<=text.clientHeight+1;
    });
  }
  document.addEventListener('click',event=>{
    const button=event.target.closest('.review-expand');
    if(!button)return;
    const expanded=button.getAttribute('aria-expanded')!=='true';
    button.setAttribute('aria-expanded',String(expanded));
    button.closest('.review-copy').classList.toggle('is-expanded',expanded);
    button.textContent=expanded?words.readLess:words.readMore;
  });
  let resizeFrame;
  window.addEventListener('resize',()=>{cancelAnimationFrame(resizeFrame);resizeFrame=requestAnimationFrame(measureComments);});
  function renderHome(reviews) {
    const section=document.querySelector('.reviews[aria-labelledby="reviews-title"]');
    if (!section) {
      const grid=document.querySelector('[data-product-reviews]');
      if(!grid)return;
      const choice=homeSelection(reviews);
      const second=choice.rest.find(r=>r.source!==choice.feature?.source)||choice.rest[0];
      const selected=[choice.feature,second].filter(Boolean);
      grid.innerHTML=selected.map(r=>'<article><span class="qr-stars" aria-label="'+escape(words.fiveStars)+'">★★★★★</span>'+content(r.text,4)+'<div class="qr-review-author"><span>'+escape(r.name)+'</span>'+origin(r.source)+'</div></article>').join('');
      requestAnimationFrame(measureComments);
      return;
    }
    const choice=homeSelection(reviews);
    if (!choice.feature || choice.selected.length!==5) return;
    const featured=section.querySelector('.review-feature');
    featured.dataset.reviewId=choice.feature.id;
    featured.dataset.source=choice.feature.source;
    featured.dataset.rating=choice.feature.rating;
    featured.querySelector('blockquote').innerHTML=content(choice.feature.text,3);
    featured.querySelector('.review-author').innerHTML='<span>'+escape(choice.feature.name)+'</span>'+origin(choice.feature.source);
    section.querySelector('.review-list').innerHTML=choice.rest.map(r=>'<article class="review-item" data-review-id="'+escape(r.id)+'" data-source="'+escape(r.source)+'" data-rating="'+r.rating+'"><div class="review-stars" aria-label="'+escape(words.fiveStars)+'">★★★★★</div>'+content(r.text)+'<footer><span>'+escape(r.name)+'</span>'+origin(r.source)+'</footer></article>').join('');
    requestAnimationFrame(measureComments);
  }
  let allReviews=[],filter='all',limit=12,rendered=0;
  function renderPage(reset=true) {
    const grid=document.querySelector('#review-grid');
    if (!grid) return;
    const list=eligible(allReviews,4).filter(r=>filter==='all'||r.source===filter);
    if (reset) {grid.textContent='';rendered=0;}
    grid.insertAdjacentHTML('beforeend',list.slice(rendered,limit).map(r=>'<article class="review" data-review-id="'+escape(r.id)+'" data-source="'+escape(r.source)+'" data-rating="'+r.rating+'"><div class="stars" aria-label="'+escape(words.stars.replace('__COUNT__',String(r.rating)))+'">'+'★'.repeat(r.rating)+'☆'.repeat(5-r.rating)+'</div><blockquote>'+content(r.text)+'</blockquote><footer><span>'+escape(r.name)+'</span>'+origin(r.source)+'</footer></article>').join(''));
    rendered=Math.min(limit,list.length);
    document.querySelector('#empty').style.display=list.length?'none':'block';
    const button=document.querySelector('#reviews-show-more');
    if(button) button.hidden=rendered>=list.length;
    grid.dataset.loadedCount=rendered;
    grid.dataset.availableCount=list.length;
    requestAnimationFrame(measureComments);
  }
  function readJudgeHtml(html) {
    const doc=new DOMParser().parseFromString(html,'text/html');
    return [...doc.querySelectorAll('.jdgm-rev[data-review-id]')].map(node=>({id:node.dataset.reviewId,source:'Judge.me',rating:Number(node.querySelector('[data-score]')?.dataset.score),name:node.querySelector('.jdgm-rev__author')?.textContent.trim()||words.customer,text:node.querySelector('.jdgm-rev__body')?.innerText?.trim()||node.querySelector('.jdgm-rev__body')?.textContent.trim()||'',date:new Date(node.querySelector('.jdgm-rev__timestamp')?.dataset.content).toISOString(),product:node.querySelector('.jdgm-rev__prod-link')?.textContent.trim()||''}));
  }
  async function getJson(url) {
    const controller=new AbortController();
    const timeout=setTimeout(()=>controller.abort(),12000);
    try {const r=await fetch(url,{signal:controller.signal});if(!r.ok)throw new Error(r.status);return await r.json();} finally {clearTimeout(timeout);}
  }
  async function allJudge() {
    const result=[];
    await Promise.all(['product-reviews','shop-reviews'].map(async type=>{
      let total=Infinity,page=1,received=0;
      while(received<total) {
        const url=new URL(config.judgeAllUrl);
        Object.entries({shop_domain:config.shop,url:config.shop,platform:'shopify',review_type:type,page}).forEach(([k,v])=>url.searchParams.set(k,v));
        const data=await getJson(url);
        const count=Number(type==='product-reviews'?data.number_of_product_reviews:data.number_of_shop_reviews);
        if(Number.isFinite(count))total=count;
        const records=readJudgeHtml(data.html||'');
        if(!records.length)break;
        result.push(...records);received+=records.length;page++;
      }
    }));
    return result;
  }
  async function latestJudge() {
    const data=await getJson(config.judgeCarouselUrl);
    return (data.reviews||[]).map(r=>({id:r.uuid,source:'Judge.me',rating:Number(r.rating),name:r.reviewer_name||words.customer,text:r.body||'',date:r.created_at,product:r.product_title||''}));
  }
  async function google() {
    const result=await getJson(config.googleUrl);
    return (result.data?.reviews||[]).map(r=>({id:r.id,source:'Google',rating:Number(r.rating),name:r.author_name,text:r.text||'',date:new Date(r.time*1000).toISOString(),url:r.author_url}));
  }
  const merge = values => [...new Map(values.map(r=>[r.source+':'+r.id,r])).values()];
  async function start() {
    const isPage=!!document.querySelector('#review-grid');
    const snapshot=await getJson(config.snapshotUrl);
    allReviews=snapshot.reviews;
    if(isPage) {
      renderPage();
      document.querySelectorAll('.filter[data-source]').forEach(button=>button.addEventListener('click',()=>{document.querySelectorAll('.filter[data-source]').forEach(b=>b.setAttribute('aria-pressed','false'));button.setAttribute('aria-pressed','true');filter=button.dataset.source;limit=12;renderPage();}));
      document.querySelector('#reviews-show-more')?.addEventListener('click',()=>{limit+=12;renderPage(false);});
    } else renderHome(allReviews);
    const updates=await Promise.allSettled([isPage?allJudge():latestJudge(),google()]);
    updates.forEach((update,index)=>{
      configNode.dataset[index===0?'judgeSync':'googleSync']=update.status;
      if(update.status==='fulfilled')allReviews=merge([...allReviews,...update.value]);
    });
    if(isPage)renderPage();else renderHome(allReviews);
  }
  start().catch(()=>{});
})();
